const en = {
  // common
  'Loading...': 'XXzz',
  Yes: 'Yes',
  No: 'No',

  Bar: 'XXzz',
  bar: 'XXzz',
  'm^3/min': 'XXzz',
  'm3/min': 'XXzz',
  kW: 'XXzz',
  PRESSURE: 'XXzz',
  'SPECIFIC POWER': 'XXzz',
  pressure: 'XXzz',
  flow: 'XXzz',
  power: 'XXzz',
  PSI: 'XXzz',
  psi: 'XXzz',
  CFM: 'XXzz',
  cfm: 'XXzz',
  RPM: 'XXzz',
  temperature: 'XXzz',
  Temperature: 'XXzz',
  Celsius: 'XXzz',
  celsius: 'XXzz',
  Fahrenheit: 'XXzz',
  fahrenheit: 'XXzz',
  current: 'XXzz',
  'Oil temperature': 'XXzz',
  'Inverter speed': 'XXzz',
  'Run hours': 'XXzz',
  'Load hours': 'XXzz',

  // login page
  'Welcome to EcoPlant': 'XXzz',
  'For technical support email us at:': 'XXzz',
  'EcoPlant 2020. All right reserved.': 'XXzz',
  'Email Address': 'XXzz',
  Password: 'XXzz',
  Login: 'XXzz',
  'Enter a verification code': 'XXzz',
  'Send Again': 'XXzz',
  Done: 'XXzz',
  Cancel: 'XXzz',
  'SMS with a verification code was sent to your phone': 'XXzz',
  'Forgot Password': 'ZZZxx',

  // side menu
  "Eco plant's logo": 'XXzz',
  'Log out': 'XXzz',

  // eco score card
  'ECO RATING': 'XXzz',
  'Specific power': 'XXzz',
  'kW/(m^3/min)': 'XXzz',
  'kW/(m3/min)': 'XXzz',
  'kW/100CFM': 'XXzz',

  // alerts
  ALERTS: 'XXzz',
  All: 'XXzz',
  Service: 'XXzz',
  service: 'XXzz',
  Warning: 'XXzz',
  warning: 'XXzz',
  Shutdown: 'XXzz',
  shutdown: 'XXzz',
  Custom: 'XXzz',
  Manufacturer: 'XXzz',
  'No more alerts to show': 'XXzz',
  'No alerts to show for this severity type.': 'XXzz',
  RECOMMENDATION: 'XXzz',
  'No archived alerts yet.': 'XXzz',
  'Or contact us via:': 'XXzz',
  noAlertsToShow: 'No alerts to show. You can view old alerts under the <1>Archive tab</1>.',
  'Archive Alert': 'XXzz',
  'Unarchive alert failed': 'XXzz',
  "View Alert record's rule (logic)": 'XXzz',
  'Auto & manually archived alerts': 'XXzz',

  // main
  Map: 'XXzz',
  Trends: 'XXzz',
  Investigation: 'XXzz',
  'Reset zoom': 'XXzz',

  // MapKPI
  FLOW: 'XXzz',
  POWER: 'XXzz',
  'Value may depend on multiple sensors and average values over time.': 'XXzz',

  // Trends
  UTC: 'XXzz',
  Yesterday: 'XXzz',
  'Last 24 hours': 'XXzz',
  'Last 7 days': 'XXzz',
  'Last 30 days': 'XXzz',
  'Last 90 days': 'XXzz',

  Pressure: 'XXzz',
  Flow: 'XXzz',
  Power: 'XXzz',
  'Specific Power': 'XXzz',
  'specific power': 'XXzz',
  'Please choose at least one graph.': 'XXzz',

  // trends - tooltip
  second: 'XXzz',
  seconds: 'XXzz',
  minute: 'XXzz',
  minutes: 'XXzz',
  hour: 'XXzz',
  hours: 'XXzz',
  day: 'XXzz',
  week: 'XXzz',
  month: 'XXzz',
  '{{value}} {{unit}} average': 'XXzz',

  // device modal
  Run: 'XXzz',
  Load: 'XXzz',
  Unload: 'XXzz',
  Off: 'XXzz',
  capacity: 'XXzz',
  Liter: 'XXzz',
  liter: 'XXzz',
  Gallon: 'XXzz',
  gallon: 'XXzz',
  'pipe diameter': 'XXzz',
  inch: 'XXzz',
  mm: 'XXzz',
  'dew point temperature': 'XXzz',
  activity: 'XXzz',
  Connected: 'XXzz',
  'Not connected': 'XXzz',
  'No State': 'XXXXXzzzzz',
  connectivity: 'XXzz',
  Auto: 'XXzz',
  Manual: 'XXzz',
  'Min set point': 'XXzz',
  'Max set point': 'XXzz',
  'NEXT SERVICE IN': 'XXzz',
  h: 'XXzz',
  'NEXT SERVICE TYPE': 'XXzz',
  WORKING_HOURS: 'XXzz',
  HORSE_POWER: 'XXzz',
  'control mode': 'XXzz',
  'filter type': 'XXzz',
  'last service': 'XXzz',

  // node factory
  Filter: 'XXzz',
  Compressor: 'XXzz',
  HP: 'XXzz',
  'Desiccant Air Dryer': 'XXzz',
  Desiccant: 'XXzz',
  'Dew Point Sensor': 'XXzz',
  'Dry Air Tank': 'XXzz',
  Dry: 'XXzz',
  'Combo Sensor': 'XXzz',
  'Flow Sensor': 'XXzz',
  'Pressure Sensor': 'XXzz',
  'Production Floor': 'XXzz',
  'Refrigerated Air Dryer': 'XXzz',
  Refrigerated: 'XXzz',
  'Wet Air Tank': 'XXzz',
  Wet: 'XXzz',

  // alert rules
  'The logic triggering alerts': 'XXzz',
  'Alert rules management': 'XXzz',
  'My rules': 'XXzz',
  'No rules to display': 'XXzz',
  'Rule condition:': 'XXzz',
  and: 'XXzz',
  or: 'XXzz',
  of: 'XXzz',
  is: 'XXzz',
  greaterThan: 'XXzz',
  equalTo: 'XXzz',
  greaterThanOrEqualTo: 'XXzz',
  lessThan: 'XXzz',
  lessThanOrEqualTo: 'XXzz',
  'Filter by source': 'XXzz',
  'Filter by device': 'XXzz',
  'Create new rule': 'XXzz',
  'Rule activation status': 'XXzz',
  Severity: 'XXzz',
  'Date created': 'XXzz',
  'Last updated': 'XXzzzzzz',
  'Are you sure you want to start monitoring and alerting on this type of events?': 'XXzz',
  'Are you sure you want to stop monitoring and alerting on this type of events?': 'XXzz',
  'Failed to change activation status': 'XXzz',
  'Are you sure you want to delete this rule?': 'XXzz',
  'Failed to delete rule': 'XXzz',
  'This alert rule has changed since the record you clicked on. The last change was on': 'XXXzzzz',
  'This alert rule has been deleted': 'XXzzz',

  // create edit rule
  Update: 'XXzz',
  Create: 'XXzz',
  'Create and Activate': 'XXzz',
  'Update a custom rule': 'XXzz',
  'Create a custom rule': 'XXzz',
  'Name the alerts and set their severity.': 'XXzz',
  'Define the logic for triggering alerts of different severity levels.': 'XXzz',
  'E.g. High than usual flow causes pressure drop': 'XXzz',
  Description: 'XXzz',
  'E.g. Try do the following...': 'XXzz',
  'Alert severity': 'XXzz',
  'Rule name (Title)': 'XXzz',
  'Duration (if this rule lasts for x time)': 'XXzz',
  Immediately: 'XXzz',
  'Choose the parameter you wish to monitor.': 'XXzz',
  Parameter: 'XXzz',
  'Choose a device with the above-selected monitored parameter. Select multiple devices to create a rule on a calculated parameter (e.g. Pressure difference between devices).':
    'XXzz',
  'Choose the operand and the target value threshold to trigger the alerts.': 'XXzz',
  Operand: 'XXzz',
  'Target value': 'XXzz',
  'Save and activate to start monitoring the parameter and trigger alerts according to the rule.': 'XXzz',
  'Contact us if you have any questions at:': 'XXzz',
  'Add device': 'XXzz',
  'E.g. 6.4': 'XXzz',
  'Alert rule updated successfully': 'XXzz',
  'Alert rule created successfully': 'XXzz',
  'Follow the math order of operations.': 'XXzz',
  'You dont have enough permission to create an alert, please contact your administrator.': 'XXzz',

  //error modal
  'Something went wrong': 'XXzz',
  'Please try again later.': 'XXzz',
  Dismiss: 'XXzz',

  //Proactive engine (dynamic controller)
  'Dynamic Controller': 'XXzz',
  'Controller Mode': 'XXXXzzzz',
  Activated: 'XXzz',
  Deactivated: 'XXzz',
  Unavailable: 'XXzz',
  Unknown: 'XXXzzzz',
  'Dynamic Controller is Activated': 'XXzz',
  'Are you sure?': 'XXzz',
  'Failed to activate dynamic controller': 'XXzz',
  'Failed to deactivate dynamic controller': 'XXzz',
  'Last commands': 'XXzz',
  Device: 'XXzz',
  'New Value': 'XXzz',
  User: 'XXzz',
  Status: 'XXzz',
  Reason: 'XXzz',
  'Date Created': 'XXzz',
  'No commands to show': 'XXzz',
  'Load more': 'XXzz',

  //Investigation dashboard
  'Investigate by Devices': 'XXzz',
  'Show me (from-to)': 'XXzz',
  'Compare with (Show me from-to)': 'XXzz',
  'You can choose up to 10 parameters per time period. When comparing 2 time periods, you can choose up to 5 parameters.':
    'XXzz',
  'When comparing 2 time periods, you can choose up to 5 parameters.': 'XXzz',
  'Station KPIs': 'XXzz',
  'Pressure drop': 'XXXzzzz',
  'No data.': 'XXzz',

  //Station control center
  'Station Control Center': 'XXXz',
  TARGET: 'XXXzzz',
  'IN MAINTENANCE': 'XXXzzzzz',
};

export default en;
